// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';
import { USER_TYPE_CONTRACTOR, USER_TYPE_SHOPADMIN, USER_TYPE_SUPER_ADMIN } from 'src/config-global';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export default function NavMini() {

  const { user } = useMockedUser();

  const isAdmin = user?.user_type === USER_TYPE_SUPER_ADMIN;

  const isShopAdmin = user?.user_type === USER_TYPE_SHOPADMIN

  const isContractor = user?.user_type === USER_TYPE_CONTRACTOR

  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2, width: 60, height: 50 }} src={isContractor && user?.company?.image || ""} href={
          isContractor ? paths.dashboard.account : isShopAdmin ? paths.shopAdminDashboard.root : paths.superAdminDashboard.root} alt
          state={{
            isEditCompany: !isAdmin,
          }}
        />

        <NavSectionMini
          data={navData}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
      </Stack>
    </Box>
  );
}
